import { InputNumber } from 'antd';
import FormField from 'components/FormField';
import TransComponent from 'components/TransComponent';
import { FV } from './share';
import { T, useTranslate } from '@tolgee/react';

function DelayShipDelayDayField(props: { disabled?: boolean }) {
  const { disabled = false } = props;

  const { t } = useTranslate();

  return (
    <FormField<FV['delayShipPolicyConfig']['delayDay']>
      name="delayShipPolicyConfig.delayDay"
      required
      label={t('marketing.执行时间')}
      validate={(value) =>
        value ? undefined : t('department.请输入x', { x: t('marketing.执行时间') })
      }
    >
      {({ field: { value, onChange, onBlur } }) => {
        return (
          <T
            keyName="aide.买家下单x天后订单仍未发货"
            params={{
              x: (
                <TransComponent
                  content={
                    <InputNumber
                      disabled={disabled}
                      value={value}
                      onChange={(value) => onChange(value as number)}
                      onBlur={onBlur}
                      min={1}
                      max={10}
                      precision={0}
                      style={{ margin: '0 4px' }}
                    />
                  }
                />
              ),
            }}
          />
        );
      }}
    </FormField>
  );
}

export default DelayShipDelayDayField;
